import React from 'react';
import { MUST_PICK_CM_MIN, MUST_PICK_CM_MAX } from '../../fields.constants';
import { HighRiskTerm } from '../HighRiskTerm';
import {
  Group,
  ThresholdLabel,
  CmInput,
  LockNote,
  Hint,
  Warning
} from './PickList.styles';

const INPUT_ID = 'pick-list-must-pick-cm';
const HINT_ID = 'pick-list-must-pick-cm-hint';
const SAVE_ERROR = 'Could not save the number. Try again.';

export const MustPickCmField = ({
  text,
  isValid,
  shownCm,
  saveError,
  onChange,
  onBlur
}) => (
  <Group>
    <ThresholdLabel htmlFor={INPUT_ID}>
      <span>
        <HighRiskTerm mustPickCm={shownCm} /> is any stone
      </span>
      <CmInput
        id={INPUT_ID}
        type='number'
        step='any'
        min={MUST_PICK_CM_MIN}
        max={MUST_PICK_CM_MAX}
        value={text}
        aria-invalid={!isValid}
        aria-describedby={isValid ? undefined : HINT_ID}
        data-testid={INPUT_ID}
        onChange={onChange}
        onBlur={onBlur}
      />
      cm and bigger
    </ThresholdLabel>
    <LockNote>
      🔒 Every stone {shownCm} cm or bigger always goes on the pick list and in the file
      for the picker. The slider below can&apos;t take them off — only changing this
      number can.
    </LockNote>
    {!isValid && (
      <Hint id={HINT_ID}>
        Enter a number from {MUST_PICK_CM_MIN} to {MUST_PICK_CM_MAX}.
      </Hint>
    )}
    {saveError && <Warning role='alert'>{SAVE_ERROR}</Warning>}
  </Group>
);
